/**
 * scssを読み込み
 */
import './scss/style.scss';

/**
 * jQueryを読み込み
 */
import $ from 'jquery';

/**
 * Slickを読み込み
 */
import 'slick-carousel';

/**
 * scriptを読み込み
 */
import './js/webfont.js';
import './js/slick-scroll.js';
import './js/showClock.js';